import React from 'react';

import fetch from '../fetch';

import utils from '../../utils';

import {Popover} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},
    {key:'parentCategoryName', label: '上层分类'},
    {key:'categoryName', label: '最下层分类',render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.categoryPathStr
                }
            </div>} 
            title="分类路径"
            >
            {value}
        </Popover>
    </span> 
    },
    {key:'categoryItem', label: '定量依据'},
    {key:'resultValue',label:'实际值'},
    // {key:'uploadFile', label: '佐证材料'},
    // {type:'action', label: '佐证材料', values: ['read', 'down', 'file']},
];

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},
    {key:'parentCategoryName', label: '上层分类'},
    {key:'categoryName', label: '最下层分类',render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.categoryPathStr
                }
            </div>} 
            title="分类路径"
            >
            {value}
        </Popover>
    </span> 
    },
    {key:'categoryItem', label: '定量依据'},
    {key:'resultValue',label:'实际值'},
    // {key:'uploadFile', label: '佐证材料'},
    // {type:'action', label: '佐证材料', values: ['read', 'down', 'file']},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('supv/taskitemStat/query', keywords)
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = [] 
        if(extParams) {
            for(let i = 0; i < columnsArray.length; i++) {
                newArray.push(columnsArray[i])
                if(i === 4) {
                    if(extParams.options.length > 0){
                        extParams.options.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value, 
                                width: 120
                            })
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(newArray.length > 0 ? newArray :columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.uploadFile,
            checked: false
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

export default {
    querySearch,
    headers,
    download: fetch.base + 'supvfile/download?id=',
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    getSelectionData,
}